import React from 'react';
import { Layout } from 'features/common/components/Layout';
import { ResumeByPax } from './ResumeByPax';

export const SalesOrderResumeByPaxPage = (): JSX.Element => {
	return (
		<Layout>
			<ResumeByPax />
		</Layout>
	);
};
